import { useQuery } from 'react-query'
import { initPaymentWallet } from 'services/wallet'

export default function useGetInitPaymentOs(
    id: undefined | number,
    amount?: any,
    payment?: any
) {
    const { data, isLoading } = useQuery(
        ['init-payment-os-wallet', id, amount, payment],
        initPaymentWallet
    )
    console.log('data: ', data)
    return { data, isLoading }
}
